import { atom } from 'jotai';

export const atom_forceAssignLineItemIdDialog = atom<string>('');
export const atom_forceAssignAvailableCreativesLineItemIdDialog = atom<string>('');
export const atom_forceUnAssignLineItemIdDialog = atom<string>('');
